import { useEffect } from 'react';
import { useMatch } from 'react-router-dom';

import { useConfiguration } from '@ocx/data-configuration';

import { AppRoutePath } from '../../AppRoutePath';
import { isSurveyWasTriggeredOnAppStart } from '../../../modules/survey/survey.reactive-variables';
import { useTriggerSurveyOnMembershipCompleted } from './use-trigger-survey-on-membership-completed.hook';

const fallbackFetchAndOpenSurveyModal = async () => {};

export const useHomeSurveyEffect = () => {
  const {
    config: { surveys },
  } = useConfiguration();
  const surveyRouteMatch = useMatch(`${AppRoutePath.Home}${AppRoutePath.SurveyDetails}`);
  const shouldTriggerSurvey = !surveyRouteMatch;
  const { fetchAndOpenSurveyModal, triggerSurveyOnMembershipCompleted } = useTriggerSurveyOnMembershipCompleted();

  useEffect(() => {
    if (!surveys.enabled) {
      return;
    }

    if (shouldTriggerSurvey) {
      triggerSurveyOnMembershipCompleted();
    } else {
      isSurveyWasTriggeredOnAppStart(true);
    }
  }, [surveys.enabled, triggerSurveyOnMembershipCompleted, shouldTriggerSurvey]);

  return {
    fetchAndOpenSurveyModal: surveys.enabled ? fetchAndOpenSurveyModal : fallbackFetchAndOpenSurveyModal,
  };
};
